export const ORGANIZATIONS = [
    { org_id: 1, name: 'Ahana' },
    { org_id: 4, name: 'Msctrf' },
];
